export var BuyerResearchStage;
(function (BuyerResearchStage) {
    BuyerResearchStage["Unspecified"] = "unspecified";
    BuyerResearchStage["Decision"] = "Decision";
    BuyerResearchStage["Consideration"] = "Consideration";
    BuyerResearchStage["Interest"] = "Interest";
    BuyerResearchStage["Awareness"] = "Awareness";
    BuyerResearchStage["All"] = "All";
    BuyerResearchStage["NoData"] = "No Data";
})(BuyerResearchStage || (BuyerResearchStage = {}));
export var BuyerResearchStageWithNonActive;
(function (BuyerResearchStageWithNonActive) {
    BuyerResearchStageWithNonActive["Decision"] = "Decision";
    BuyerResearchStageWithNonActive["Consideration"] = "Consideration";
    BuyerResearchStageWithNonActive["Interest"] = "Interest";
    BuyerResearchStageWithNonActive["Awareness"] = "Awareness";
    BuyerResearchStageWithNonActive["NonActive"] = "Non-Active";
})(BuyerResearchStageWithNonActive || (BuyerResearchStageWithNonActive = {}));
export const BuyerResearchStageMap = {
    Decision: 4,
    Consideration: 3,
    Interest: 2,
    Awareness: 1,
    'No Data': 0,
};
export const BuyerResearchStageRank = {
    Decision: 4,
    Consideration: 3,
    Interest: 2,
    Awareness: 1,
    'No Data': 0,
};
export const brsOptions = Object.values(BuyerResearchStage)
    .filter((buyerResearchStage) => !['unspecified', 'No Data', 'All'].includes(buyerResearchStage))
    .map((buyerResearchStage) => ({
    value: buyerResearchStage,
    label: buyerResearchStage,
}));
export const brsOptionsWithNonActive = Object.values(BuyerResearchStageWithNonActive).map((buyerResearchStage) => ({
    value: buyerResearchStage,
    label: buyerResearchStage,
}));
//# sourceMappingURL=BuyerResearchStage.js.map